var groups = {
	0 : ['0','1','2','3'],
	1 : ['4','5','6','7'],
	2 : ['8','9','a','b'],
	3 : ['c','d','e','f']
};

$.urlParam = function(name){
    var results = new RegExp('[\\?&amp;]' + name + '=([^&amp;#]*)').exec(window.location.href);
    return results[1] || 0;
};

var param = $.urlParam('param').toLowerCase();

for (var key in groups) {
	if ($.inArray(param, groups[key]) > -1){
		window.location.href = "lp-chrome-awake-" + key;
	}
}